import React from 'react'
import styles from './styles.module.less'
import { useFormatMessage } from '../../utils'
import { version } from '../../../package.json'

export const AppFooter = () => {
  const formatMessage = useFormatMessage()

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        <div className={styles.footerParagraphWrapper}>
          <p className={styles.footerParagraph}>
            FINRA BrokerCheck reports for Apex Clearing are available at{' '}
            <a href='http://www.finra.org/brokercheck' target='_blank' rel='noopener noreferrer'>
              http://www.finra.org/brokercheck
            </a>
          </p>
          <p className={`${styles.footerLinks} ${styles.footerParagraph}`}>
            <a ng-href='https://www.apexclearing.com/privacy-policy' href='https://www.apexclearing.com/privacy-policy'>
              Privacy Policy
            </a>
            <a ng-href='https://www.apexclearing.com/disclosures' href='https://www.apexclearing.com/disclosures'>
              Other Disclosures
            </a>
            <a
              ng-href='https://www.apexclearing.com/futures-disclosures'
              href='https://www.apexclearing.com/futures-disclosures'
            >
              Futures Disclosures
            </a>
            <a ng-href='https://www.apexclearing.com/press' href='https://www.apexclearing.com/press'>
              Press
            </a>
          </p>
        </div>
      </div>
      <div className={styles.footerCopyright}>
        <div data-testid='test-id-copyright'>
          <span>{`${formatMessage('common.copyrightSymbol')} ${new Date().getFullYear()} ${formatMessage(
            'common.apexClearingCorp'
          )}`}</span>
        </div>
        <div>
          {formatMessage('common.footer.member')} | ver {version}
        </div>
      </div>
    </footer>
  )
}
